import gql from "graphql-tag";

export const FULL_CUSTOMER_FRAGMENT = gql`
	fragment FullCustomer on Customer {
		organization
		customerId
		customerNumber
		salesTaxId
		addresses {
			addressId
			label
			addressLine1
			addressLine2
			addressTypeId
			city
			state
			postalCode
			isPrimaryAddress
			isActive
			contactId
			organization
			department
			contact {
				contactId
				firstName
				lastName
				email
				workPhoneNumber
				cellPhoneNumber
			}
		}
		contacts {
			contactId
			primaryContact
			firstName
			lastName
			workPhoneNumber
			cellPhoneNumber
			email
			isActive
		}
	}
`;

export const NOTES_INFO = gql`
	fragment NotesInfo on Note {
		noteId
		text: noteText
		createdBy
		noteDate: createdAt
		noteType
	}
`;

export const SALES_PAYMENT_INFO = gql`
	fragment SalesPaymentInfo on SalesPayment {
		salesPaymentId
		amount
		paymentDate
		name
		paymentMethodId
		referenceNumber
		schoolOrOrganization
	}
`;

export const PURCHASE_ORDER_INFO = gql`
	fragment PurchaseOrderInfo on PurchaseOrder {
		id
		processTypeId
		purchaseOrderNumber
		vendorId
		vendorContactId
		salesOrderId
		dropShip
		contactId
		customerAddressId
		shippingMethodId
		purchaseOrderDate
		expectedDate
		purchaseOrderPrinted
		packingSlipPrinted
		modifiedAt
		createdAt
		modifiedBy
		createdBy
		isLocked
		dropShip
		isCancelled
		isAttaching
		lineItemId
		parentItem {
			parentPoId
			parentLineItemId
			lineNumber
		}
		childItems {
			childPoId
			lineItemId
			lineNumber
		}
		attachItems {
			attachPoId
			lineItemId
			lineNumber
		}
		customerAddress {
			addressId
			addressLine2
			addressLine1
		}
		notes {
			id
			noteText
			noteType
			createdBy
			modifiedBy
			modifiedAt
			createdAt
			purchaseOrderId
		}
		receivedItems {
			id
			receivedDate
			quantityReceived
		}
		items {
			salesOrderLineItemId
			quantity
			unitPrice
			totalSizes
			hasSizes
			matchPreviousPoNumber
			note
			braidPosition
			itemOrdered {
				systemCategoryId
				systemCategory
				inventoryItemId
				styleCode
				description
				processType
				processTypeId
				vendorPartNumber
				isStock
			}
			inventoryItem {
				inventoryItemId
				sizeChart {
					sizeChartId
					name
					sizes {
						sizeId
						name
						sequence
					}
				}
			}
			sizes {
				size
				length
				sizeId
				lengthId
				quantity
			}
			specialSizes {
				length
				quantity
				size
			}
			colors {
				colorOption
				description
				color
				colorId
			}
			freeTextSelections {
				text
				colorOptionId
			}
			lettering {
				letterPositionId
				text
			}
			letteringText
			subItems {
				salesOrderLineItemId
				matchPreviousPoNumber
				note
				braidPosition
				colors {
					colorOption
					description
					color
					colorId
				}
				itemOrdered {
					systemCategoryId
					systemCategory
					inventoryItemId
					styleCode
					description
					processType
					processTypeId
					vendorPartNumber
					isStock
				}
				lettering {
					letterPositionId
					text
				}
				letteringText
			}
		}
	}
`;
